import {useState} from 'react'
import styled from 'styled-components'
import {Api} from '../lib/api'
import {Alert} from './Alert'
import {Button, ButtonGroup} from './Button'
import {Modal} from './Modal'
import {TextInput} from './TextInput'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
`
const Intro = styled.p`
  margin-bottom: 20px;
  color: ${p => p.theme.colors.primary};
`

const getPlaylistIdFromUrl = (url: string) => {
  const parsed = url.match(/(\w+)(?:$|\?)/i)
  return parsed && parsed?.length >= 2 ? parsed[1] : undefined
}

export const NewPlaylistModal = ({
  onClose,
  open = true,
  onAdd
}: {
  open?: boolean
  onAdd?: (id: string) => void
  onClose: () => void
}) => {
  const [url, setUrl] = useState('')
  const [error, setError] = useState<string>()
  const valid = !!url

  return (
    <Modal open={open} onClose={onClose}>
      <Form
        onSubmit={async e => {
          e.preventDefault()
          setError(undefined)
          const id = getPlaylistIdFromUrl(url)
          if (id) {
            const ok = await Api.add(id)
            if (ok) {
              if (onAdd) {
                onAdd(id)
              }
              onClose()
            } else {
              setError("Sorry I wasn't able add that")
            }
          } else {
            setError("Sorry I couldn't parse that")
          }
        }}
      >
        {error && <Alert type="polite">{error}</Alert>}
        <Intro>
          To add a playlist paste the link that Spotify gives you via the share
          menu.
        </Intro>
        <TextInput
          placeholder="Spotify URL"
          value={url}
          onChange={e => setUrl(e.target.value)}
        />

        <ButtonGroup>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={!valid}>
            Add
          </Button>
        </ButtonGroup>
      </Form>
    </Modal>
  )
}
